import React from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import CheckcircleIcon from 'icons/Checkcircle.icon';

import './AddonCard.styles.scss';
import './AddonCard.styles.responsive.scss';

export type AddonCardOption = {
  title: string;
  price: string;
  description?: string;
  ctaText?: string;
  list: string[];
};

type AddonCardProps = {
  className?: string;
  isSelected: boolean;
  onClick: () => void;
} & AddonCardOption;

const AddonCard: React.FC<AddonCardProps> = (props) => {
  const {
    className,
    title,
    price,
    description,
    list,
    ctaText,
    isSelected,
    onClick,
  } = props;

  const classes = classNames(
    'addon-card',
    'white-panel',
    { selected: isSelected },
    className,
  );
  const { t } = useTranslation();

  return (
    <div className={classes}>
      <div className="heading">
        <p className="title">{t(title)}</p>
        <p className="price">{price}</p>
      </div>

      {description && <p>{t(description)}</p>}

      <div className="list-with-button">
        <ul>
          {list.map((item) => (
            <li key={item}>{t(item)}</li>
          ))}
        </ul>

        <Button
          iconPosition="right"
          icon={isSelected ? CheckcircleIcon : null}
          onClick={onClick}
        >
          {t(isSelected ? 'selected' : ctaText || 'add')}
        </Button>
      </div>
    </div>
  );
};

export default AddonCard;
